module.exports = __webpack_public_path__ + "static/media/deactivated.6358b457.png";